export default "__VITE_ASSET__Dsnu0qd9__"